import { render, staticRenderFns } from "./registeredList.vue?vue&type=template&id=742a9177"
import script from "./registeredList.vue?vue&type=script&lang=js"
export * from "./registeredList.vue?vue&type=script&lang=js"
import style0 from "./registeredList.vue?vue&type=style&index=0&id=742a9177&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports